var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "configuration-controls" }, [
      _c(
        "div",
        { staticClass: "individual-control journey-selector" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.resource("JourneyBuilder_Shared_Journey")))
          ]),
          _vm._v(" "),
          _c("journey-dropdown", {
            model: {
              value: _vm.journeyIdModel,
              callback: function($$v) {
                _vm.journeyIdModel = $$v
              },
              expression: "journeyIdModel"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "individual-control period-selector" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.resource("JourneyBuilder_Sankey_Period_Label")))
          ]),
          _vm._v(" "),
          _c("period-picker")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "individual-control inflow-period-selector" },
        [
          _c("label", [
            _vm._v(
              _vm._s(_vm.resource("JourneyBuilder_Sankey_InflowPeriod_Label"))
            )
          ]),
          _vm._v(" "),
          _c("inflow-period-picker")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "individual-control product-selector" },
        [
          _c("label", [
            _vm._v(
              _vm._s(_vm.resource("JourneyBuilder_Sankey_ProductIds_Label"))
            )
          ]),
          _vm._v(" "),
          _c("products-selector")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "individual-control highlight-mode-selector" },
        [
          _c("label", [
            _vm._v(
              _vm._s(_vm.resource("JourneyBuilder_Sankey_HighlightMode_Label"))
            )
          ]),
          _vm._v(" "),
          _c("highlight-mode-selector")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "individual-control tag-route-type-selector" },
        [
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.resource("JourneyBuilder_Sankey_GoalRouteToggle_Label")
              )
            )
          ]),
          _vm._v(" "),
          _c("tag-route-type-selector")
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sankey-explanation" }, [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.resource(
                "JourneyBuilder_Sankey_TouchpointSelection_Explanation"
              )
            )
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }